import React from "react";

interface SelectProps {
  options: {
    value: string;
    label: string;
  }[];
  label?: string;
  onChange: (value: string) => void;
  currentValue?: string;
  disabled?: boolean;
}

const Select = ({
  options,
  label,
  onChange,
  currentValue,
  disabled,
}: SelectProps): JSX.Element => {
  const arrowIcon = `<svg><use href="../../assets/sprite.svg#chevron-down" /></svg>`;

  return (
    <select
      className={`block
      w-full px-3 py-2 text-base font-normal text-white bg-black/20 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded-sm transition ease-in-out m-0 focus:border-blue-600 focus:outline-none bg-[url(data:image/svg+xml;uft8,${arrowIcon})]`}
      aria-label={label || "Select"}
      onChange={(event) => onChange(event.target.value)}
      value={currentValue || label}
      disabled={!!disabled}
    >
      {label && !currentValue && (
        <option className="bg-gray-900 text-white p-2" value={label}>
          {label}
        </option>
      )}
      {options.map((option, index) => (
        <option
          className="bg-gray-900 text-white p-2 h-6"
          value={option.value}
          key={index}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
